export default {
  desktop: 1024,
  tablet: 850,
  mobile: 525,
};
